import { toast } from 'react-toastify';

import { isEmail } from './common';

type InputsType = Record<string, string>;

export const validateFindEmail = (inputs: InputsType) => {
    const { name, cellphone } = inputs;
    let validity = true;

    if (!name) {
        toast.warning('이름을 입력해주세요');
        validity = false;
    } else if (!cellphone || cellphone.length < 11) {
        toast.warning('휴대폰번호를 정확히 입력해주세요');
        validity = false;
    }
    return validity;
};

export const validateFindPw = (inputs: InputsType) => {
    const { email, name, cellphone } = inputs;
    let validity = true;

    if (!isEmail(email)) {
        toast.warning('이메일을 정확히 입력해주세요');
        validity = false;
    } else if (!name) {
        toast.warning('이름을 입력해주세요');
        validity = false;
    } else if (!cellphone || cellphone.length < 11) {
        toast.warning('휴대폰번호를 정확히 입력해주세요');
        validity = false;
    }
    return validity;
};

export const validateChangePw = (firstLogin: boolean, inputs: InputsType) => {
    const { currentPw, newPw, confirmPw } = inputs;
    let validity = true;

    if (!firstLogin && !currentPw) {
        toast.warning('현재 비밀번호를 입력해주세요.');
        validity = false;
    } else if (!newPw) {
        toast.warning('변경할 비밀번호를 입력해주세요.');
        validity = false;
    } else if (!confirmPw) {
        toast.warning('비밀번호 확인을 입력해주세요.');
        validity = false;
    }
    return validity;
};

export const validateSystemOperator = (
    account: string,
    name: string,
    cellphone: string
) => {
    let validity = true;

    if (!isEmail(account)) {
        toast.warning('이메일을 정확하게 입력해주세요.');
        validity = false;
    } else if (!name) {
        toast.warning('이름을 입력해주세요.');
        validity = false;
    } else if (cellphone.length < 11) {
        toast.warning('핸드폰 번호를 정확하게 입력해주세요.');
        validity = false;
    }
    return validity;
};
